import React from 'react';
import { VscHistory } from 'react-icons/vsc';
import Tooltip from './Tooltip';

interface Props {
    onClick: any;
}

function HistoryButton({ onClick }: Props) {
    return (
        <Tooltip tooltipTxt="Histórico">
            <VscHistory className="history-btn" size={20} onClick={onClick} />
        </Tooltip>
    );
}

export default HistoryButton;